import _objectWithoutProperties from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["isScrollable", "isScrolling", "isRound", "isSelected", "inactiveBackground", "inactiveBorderColor", "inactiveTextColor", "selectedBackground", "selectedBorderColor", "selectedTextColor"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

import { __rest } from "tslib";
import React from "react";
import { animated } from "react-spring";
import styled, { css } from "styled-components";
import { size, typography } from "../../shared/constants";
import { SVG } from "../Icons/styles";
export var AnimatedActiveIndicator = styled(animated.div)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: ", "px;\n"])), function (_ref) {
  var e = _ref.background;
  return e;
}, size.xs2);
export var Tab = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 23px;\n  margin: 0;\n  padding: 0;\n  letter-spacing: 0.5px;\n  line-height: ", "px;\n  text-transform: capitalize;\n  font-weight: ", ";\n"])), size.xl1, typography.weight.book);

var ScrollableItemStyle = function ScrollableItemStyle(e) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  user-select: none;\n  cursor: ", ";\n\n  ", " {\n    white-space: nowrap;\n  }\n"])), e ? "grabbing" : "", Tab);
},
    SelectedItemStyle = function SelectedItemStyle(_ref2) {
  var e = _ref2.selectedBackground,
      o = _ref2.selectedBorderColor,
      t = _ref2.selectedTextColor;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: ", ";\n\n  ", " {\n    color: ", ";\n  }\n"])), e, o ? "1.5px solid ".concat(o) : "none", Tab, t);
},
    RoundedItemStyle = function RoundedItemStyle(_ref3) {
  var e = _ref3.isSelected,
      o = _ref3.inactiveBorderColor,
      t = _ref3.inactiveTextColor,
      r = _ref3.selectedBackground,
      l = _ref3.selectedBorderColor,
      i = _ref3.selectedTextColor;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: ", "px ", "px;\n  border-radius: ", "px;\n  height: 36px; /** Height from figma design */\n  display: flex;\n  align-items: center;\n  border: 1.5px solid ", ";\n\n  ", " {\n    color: ", ";\n  }\n\n  ", ";\n"])), size.xs2, size.sm, size.md, o, Tab, t, e && SelectedItemStyle({
    selectedBackground: r,
    selectedBorderColor: l,
    selectedTextColor: i
  }));
};

export var Item = styled(function (_ref4) {
  var e = _ref4.isScrollable,
      o = _ref4.isScrolling,
      t = _ref4.isRound,
      r = _ref4.isSelected,
      l = _ref4.inactiveBackground,
      i = _ref4.inactiveBorderColor,
      s = _ref4.inactiveTextColor,
      c = _ref4.selectedBackground,
      n = _ref4.selectedBorderColor,
      a = _ref4.selectedTextColor,
      d = _objectWithoutProperties(_ref4, _excluded);

  return React.createElement(animated.li, Object.assign({}, d));
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  list-style-type: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n\n  ", " {\n    ", ";\n    text-align: center;\n    color: ", ";\n  }\n\n  ", ";\n  ", ";\n"])), function (_ref5) {
  var e = _ref5.inactiveBackground;
  return e;
}, Tab, typography.buttonTextSmall, function (_ref6) {
  var e = _ref6.inactiveTextColor;
  return e;
}, function (_ref7) {
  var e = _ref7.isScrollable,
      o = _ref7.isScrolling;
  return e && ScrollableItemStyle(o);
}, function (_ref8) {
  var e = _ref8.isRound,
      o = _ref8.isSelected,
      t = _ref8.inactiveBorderColor,
      r = _ref8.inactiveTextColor,
      l = _ref8.selectedBackground,
      i = _ref8.selectedBorderColor,
      s = _ref8.selectedTextColor;
  return e && RoundedItemStyle({
    isSelected: o,
    inactiveBorderColor: t,
    inactiveTextColor: r,
    selectedBackground: l,
    selectedBorderColor: i,
    selectedTextColor: s
  });
});
export var TabItemsWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n\n  ul {\n    gap: ", "px;\n  }\n\n  ", ";\n"])), size.lg, function (_ref9) {
  var e = _ref9.isScrollable;
  return e && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      overflow-x: scroll;\n      overflow-y: hidden;\n      white-space: nowrap;\n      user-select: none;\n      scroll-behavior: smooth;\n\n      /* Hide scrollbar for Chrome, Safari and Opera */\n      ::-webkit-scrollbar {\n        display: none;\n      }\n\n      -ms-overflow-style: none; /*Hide scrollbar IE and Edge */\n      scrollbar-width: none; /* Hide scrollbar Firefox */\n\n      ul {\n        gap: ", ";\n      }\n    "])), function (_ref10) {
    var e = _ref10.isRound;
    return e ? "".concat(size.md, "px") : "";
  });
});
export var TabContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  height: ", "px;\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n"])), size.xl3, function (_ref11) {
  var e = _ref11.background;
  return e;
});
export var Tabs = styled.ul(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  width: 100%;\n\n  /* Since this is a flex element, to have padding before and after we need this hack */\n  ", "\n"])), function (_ref12) {
  var e = _ref12.fillAvailableSpace;
  return e ? "space-between" : "";
}, function (_ref13) {
  var e = _ref13.addPadding;
  return e && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      :before {\n        content: '';\n      }\n\n      :after {\n        content: '';\n        flex: 0 0 0.1px;\n      }\n    "])));
});
export var IconWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: 100%;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n\n  &:hover,\n  &:focus {\n    transform: scale(1.03);\n  }\n\n  ", " {\n    height: 13px;\n    width: 7px;\n  }\n\n  color: ", ";\n  background-color: ", ";\n  ", ";\n"])), size.xl3, SVG, function (_ref14) {
  var e = _ref14.color;
  return e;
}, function (_ref15) {
  var e = _ref15.background;
  return e;
}, function (_ref16) {
  var e = _ref16.isLeft;
  return e ? css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n          left: 0;\n        "]))) : css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n          right: 0;\n        "])));
});